import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import './styles/index.css';
import {CookiesProvider} from 'react-cookie'
// import Login from "./pages/Login";
// import Dashboard from "./pages/Dashboard";
// import Test from "./pages/Test";
// import Users from "./pages/Users";
import App from "./app";

// const root = document.getElementById("root");
//
// ReactDOM.createRoot(root).render(
//     <BrowserRouter>
//         <CookiesProvider>
//             <Routes>
//                 <Route path="/" element={<Login />} />
//                 <Route path="/dashboard" element={<Dashboard />} />
//                 <Route path="/users" element={<Users />} />
//                 <Route path="/test" element={<Test />} />
//             </Routes>
//         </CookiesProvider>
//     </BrowserRouter>
// );

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
    <BrowserRouter>
        <CookiesProvider>
            <App />
        </CookiesProvider>
    </BrowserRouter>
);
